import { FilterFilled, CloseSquareFilled, LeftOutlined, RightOutlined } from "@ant-design/icons";
import Loading from "../components/Order/Loading";
import { Pagination, Table } from "antd";
import { useEffect, useRef, useState } from "react";
import { ErrorOutline, HighlightOffRounded } from "@material-ui/icons";
import FilterChip from "./FilterChip";
import FilterPopup from "./FilterPopup";
import { makeStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import { colors } from "../constants/colors";
import { commonStrings } from "./StringBundle";

const useStyles = makeStyles((theme) => ({
    root: {
        minWidth: '100%'
    },
    formControl: {
        margin: theme.spacing(1),
        marginTop: theme.spacing(2),
        minWidth: 120,
    },
    control: {
        marginTop: 3,
        marginBottom: 3
    },
    modal: {
        position: 'absolute',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        margin: 'auto',
        top: "50%",
        right: "50%",
        transform: "translate(50%, -50%)",
        width: 900,
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${colors.nearWhite}`,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        // overflowY: 'scroll',
        maxHeight: '90vh',
        maxWidth: "90vw",
    },
    emtyText: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      color: colors.red,
      padding: "10px",
      minHeight: "100px",
    },
    stickyHeaderWrap: {
      '& .ant-table-content': {
        position: 'relative',
        overflowY: 'auto !important',
        maxHeight: 'var(--ft-max-height, calc(100vh - 250px))',
      },
      '& .ant-table-thead > tr > th': {
        position: 'sticky',
        top: 0,
        zIndex: 2,
      },
      // Hide scrollbar on table body when there is no data
      '& .ant-table-empty .ant-table-content': {
        overflowY: 'hidden !important',
      },
    },
    columnWidthCell: {
      minWidth: '75px !important',
      maxWidth: '250px !important',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      overflowWrap: 'break-word',
    },
    filterIconDefault: {
      color: 'inherit',
    },
    filterIconActive: {
      color: colors.link,
    },
    tableWrapPositioned: {
      position: 'relative',
    },
}));

// selection when checkbox or radio, if need to select a row
const FiltersTable = (props) => {
  const errMsg = "Server Error. Please contact administrator";
  const {
    columns,
    tableData,
    messageEmpty = "No Data",
    totalrecord,
    apiFilter = false,
    hasError = false,
    nopagination = false,
    errorMessage = errMsg,
    onPaginationChange,
    noPagination = false,
    customPageSizeOptions = ["10", "25", "50"],
    hideFilterIcons = false,
    defaultPageSize,
  } = props;
  const pageSizeOptions = customPageSizeOptions;
  const searchParams = new URLSearchParams(window.location.search);
  const tabValue = searchParams.get("tab");
  const pageFilter = `FiltersTable.${window.location.pathname}${tabValue ? `?tab=${tabValue}` : ""}`;
  const pageNumberStorageKey = props.id ? props.id + "selectedpagenumber" : "selectedpagenumber";
  const filterSettings = JSON.parse(sessionStorage.getItem(pageFilter));
  const classes = useStyles();
  const paginationState =
    props?.nopagination === true
      ? 1
      : sessionStorage.getItem(pageNumberStorageKey)
      ? sessionStorage.getItem(pageNumberStorageKey)
      : 1;
  const pageSizeStorageKey = props.id ? props.id + "selectedpagesize" : "selectedpagesize";
  const pageSize = sessionStorage.getItem(pageSizeStorageKey);
  const initialPageSize = Number(pageSize) || (defaultPageSize || 10);

  const [searchText, setSearchText] = useState(
    filterSettings?.[0]?.searchText || ""
  );
  const [searchedColumn, setSearchedColumn] = useState(
    filterSettings?.[0]?.searchedColumn || ""
  );
  const [filteredData, setFilteredData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filtersTableKey, setFiltersTableKey] = useState("");
  const [paginationLimit, setPaginationLimit] = useState(initialPageSize);
  const [pagination, setPagination] = useState(paginationState);
  const searchInput = useRef(null);
  const tableWrapRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const [tableBodyHeight, setTableBodyHeight] = useState(400);

  const getHScrollEl = () =>
    tableWrapRef.current?.querySelector('.ant-table-body') ||
    tableWrapRef.current?.querySelector('.ant-table-content');

  const checkScrollable = () => {
    const el = getHScrollEl();
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
  };

  const scrollByX = (dir) => {
    const el = getHScrollEl();
    if (el) el.scrollBy({ left: dir * 300, behavior: 'smooth' });
  };

  // Multi Filter Implementation Here on the FiltersTable
  useEffect(() => {
    let filteredDatas = [];

    if (_.isEmpty(filterSettings) || apiFilter) {
      filteredDatas = tableData;
    } else {
      for (let i = 0; i < tableData?.length; i++) {
        const row = tableData[i];
        let matchesAll = true;

        for (let j = 0; j < filterSettings.length; j++) {
          const filter = filterSettings[j];
          const value = row[filter.searchedColumn];

          if (
            !value ||
            !value.toString().toLowerCase().includes(filter.searchText.toLowerCase())
          ) {
            matchesAll = false;
            break;
          }
        }

        if (matchesAll) {
          filteredDatas.push(row);
        }
      }
    }

    setFilteredData(filteredDatas);
    getColumnSearchProps(searchedColumn);
  }, [searchText, searchedColumn]);


  useEffect(() => {
    let filteredDatas = tableData;
    if(tableData?.length){
      filteredDatas = tableData?.filter((data) => {
      const balanceColumn = columns.find(col => col.key === 'balance_quantity');
      const shouldFilterOutZeroBalance = balanceColumn?.filterOutZeroBalance;
      if (shouldFilterOutZeroBalance && parseFloat(data.balance_quantity) <= 0) {
        return false; 
      }
      return true;
    })
      .filter((data) =>
        searchText
          ? data[searchedColumn]
              ?.toString()
              ?.toLowerCase()
              ?.includes(searchText.toLowerCase())
          : true
      );
    }
    setFilteredData(apiFilter ? tableData : filteredDatas);
    getColumnSearchProps(searchedColumn);
    let timer = setTimeout(() => {
      setLoading(false);
    }, 4000);
    return () => clearTimeout(timer);
  }, [tableData, searchText, searchedColumn]);

  useEffect(() => {
    if (props?.pagination !== undefined) {
      setPagination(props.pagination);
    }
  }, [props.pagination]);

  useEffect(() => {
    const update = () => {
      if (!tableWrapRef.current) return;
      const top = tableWrapRef.current.getBoundingClientRect().top;
      const paginationH = noPagination ? 0 : 56;
      const available = Math.max(200, window.innerHeight - top - paginationH - 30);
  
      const naturalH = tableWrapRef.current.querySelector('.ant-table-content table')?.getBoundingClientRect().height;
      const h = naturalH ? Math.min(available, naturalH) : available;
      setTableBodyHeight(h);
      tableWrapRef.current.style.setProperty('--ft-max-height', `${h}px`);
    };
    const timer = setTimeout(update, 150);
    window.addEventListener('resize', update);
    return () => { clearTimeout(timer); window.removeEventListener('resize', update); };
  }, [filteredData, noPagination]);

  // Attach scroll listener for left/right button visibility.
  useEffect(() => {
    let cleanup;
    const timer = setTimeout(() => {
      const el = getHScrollEl();
      if (!el) return;
      checkScrollable();
      el.addEventListener('scroll', checkScrollable);
      const ro = new ResizeObserver(checkScrollable);
      ro.observe(el);
      cleanup = () => {
        el.removeEventListener('scroll', checkScrollable);
        ro.disconnect();
      };
    }, 300);
    return () => { clearTimeout(timer); cleanup?.(); };
  }, [filteredData, filtersTableKey, tableBodyHeight]);

  // on filter or enter of search
  const handleSearch = (selectedKeys, confirm, dataIndex, column) => {
    confirm();
    const selectedKeystextt = selectedKeys[0];
    if (!selectedKeystextt.trim()) {
      confirm();
      return;
    }
    let searchList = JSON.parse(sessionStorage.getItem(pageFilter)) || [];

    // Update or add the new filter
    const existingIndex = searchList.findIndex(
      (item) => item.searchedColumn === dataIndex
    );

    if (existingIndex !== -1) {
      searchList[existingIndex] = {
        searchText: selectedKeystextt,
        searchedColumn: dataIndex,
        searchedTitle: column?.title,
        type: column?.type
      };
    } else {
      searchList.push({
        searchText: selectedKeystextt,
        searchedColumn: dataIndex,
        searchedTitle: column?.title,
        type: column?.type
      });
    }

    // store searched key and value in session storage
    sessionStorage.setItem(
      pageFilter,
      JSON.stringify(searchList)
    );
    // reset pagination to 1
    setPagination(1);
    sessionStorage.setItem(pageNumberStorageKey, 1);
    // condition to check if filterDataColumn props is there or not, if there then only use else ignore 
    if (props.filterDataColumn && typeof props.filterDataColumn === 'function') {
      // pass searched key and value to list file 
      props.filterDataColumn(searchList);
    }
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
    setFiltersTableKey(Date.now());
  };
  const getColumnSearchProps = (dataIndex, column = {}) => ({
    filterDropdown: ({ selectedKeys, confirm, clearFilters, close }) => (
      <FilterPopup
        label={column?.title}
        activeValue={selectedKeys[0] || ""}
        onApply={(value) => handleSearch([value], confirm, dataIndex, column)}
        onRemove={() => clearFilters && handleReset(clearFilters)}
        onClose={close}
        inputRef={searchInput}
      />
    ),
    filterIcon: hideFilterIcons
      ? () => null
      : (filtered) => (
          <FilterFilled
            className={filtered ? classes.filterIconActive : classes.filterIconDefault}
          />
        ),
    onFilter: (value, record) =>
      !apiFilter
        ? record[dataIndex]
            ?.toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : filteredData,
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        let timer = setTimeout(() => searchInput.current?.select(), 100);
        return () => clearTimeout(timer);
      }
    },
  });
  const antColumns = columns?.map((column) => {
    // eslint-disable-next-line no-unused-vars
    const { width: _width, minWidth: _minWidth, maxWidth: _maxWidth, ...restColumn } = column;
    const visible = column.visible || true;
    if(visible) {
      if(column?.disableFilter === true){
        return {
          ...restColumn,
          onHeaderCell: () => ({ className: classes.columnWidthCell }),
          onCell: () => ({ className: classes.columnWidthCell }),
        };
      }else {
        const activeFilter = filterSettings?.find((f) => f.searchedColumn === column.dataIndex);
        return {
          ...restColumn,
          onHeaderCell: () => ({ className: classes.columnWidthCell }),
          onCell: () => ({ className: classes.columnWidthCell }),
          filteredValue: activeFilter ? [activeFilter.searchText] : null,
          ...getColumnSearchProps(column.dataIndex, column),
        };
      }
    }
  });

  // Delete Filter function
  const clearFilterSettings = (indexToRemove) => {
    const updatedFilters = [...(filterSettings || [])];
    updatedFilters.splice(indexToRemove, 1);

    sessionStorage.setItem(pageFilter, JSON.stringify(updatedFilters));
    sessionStorage.setItem(pageNumberStorageKey, 1);
    setPagination(1);

    const balanceColumn = columns.find(col => col.key === 'balance_quantity');
    const shouldFilterOutZeroBalance = balanceColumn?.filterOutZeroBalance;

    const passesZeroBalanceCheck = (data) => {
      if (!shouldFilterOutZeroBalance) return true;

      const balance = parseFloat(data.balance_quantity);
      return !isNaN(balance) && balance > 0;
    };

    if (shouldFilterOutZeroBalance) {
      const filteredDatas = tableData.filter((data) => {
        return passesZeroBalanceCheck(data);
      });
      
      setFilteredData(filteredDatas);
    }

    if (typeof props.filterDataColumn === 'function') {
      props.filterDataColumn(updatedFilters);
    }

    setFiltersTableKey(Date.now());
  };


  function onChangePagination(page, pageSize) {
    const pgNo = parseInt(page);
    setPagination(pgNo);
    setPaginationLimit(pageSize);
    // set selected page number in session storage
    !nopagination && sessionStorage.setItem(pageNumberStorageKey, pgNo);
    // set selected pagesize in session storage
    sessionStorage.setItem(pageSizeStorageKey, pageSize);
    if (onPaginationChange && typeof onPaginationChange === 'function') {
      // pass selected page number and size in list
      if(((Number(pagination) !== Number(page)) || Number(paginationLimit) !== Number(pageSize))){
        onPaginationChange(page,pageSize);
      }
    }
  }


  return (
    <>
      <FilterChip filterSettings={filterSettings} clearFilterSettings={clearFilterSettings} />
      <div ref={tableWrapRef} className={`${classes.stickyHeaderWrap} ${classes.tableWrapPositioned}`}>
        {canScrollLeft && filteredData !== null && (
          <button className="ft-scroll-btn ft-scroll-btn-left" onClick={() => scrollByX(-1)}>
            <LeftOutlined />
          </button>
        )}
        <Table
          scroll={{ x: 'max-content' }}
          getPopupContainer={(trigger) =>
            trigger?.closest('.ant-table-body') ||
            trigger?.closest('.ant-table-content') ||
            trigger?.closest('.app-content') ||
            document.body
          }
          locale={{
            emptyText: (
              <span className={classes.emtyText}>
                {filteredData === null ? (
                  <Loading />
                ) : hasError ? (
                  <>
                    <ErrorOutline /> {errorMessage}
                  </>
                ) : (
                  <>
                    <HighlightOffRounded /> {messageEmpty}
                  </>
                )}
              </span>
            ),
          }}
          columns={antColumns}
          dataSource={filteredData}
          key={filtersTableKey}
          pagination={noPagination ? false :
            {
              pageSizeOptions: pageSizeOptions,
              showSizeChanger: true,
              total: totalrecord,
              current: Number(pagination),
              pageSize: paginationLimit,
            }
          }
          onChange={(pagination, filters, sorter, extra) => {
            if (extra?.action === 'paginate') {
              onChangePagination(pagination.current, pagination.pageSize);
            }
          }}
        />
        {canScrollRight && filteredData !== null && (
          <button className="ft-scroll-btn ft-scroll-btn-right" onClick={() => scrollByX(1)}>
            <RightOutlined />
          </button>
        )}
      </div>
    </>
  );
};
export default FiltersTable;